/**
 * @fileoverview Component for displaying a reset password form.
 * This component includes a form for resetting a password and displays a message if the password is incorrect or duplicated.
 */

import { TextInput } from '../form/TextInput'

/**
 * @interface Props
 * @description Props for the ResetPasswordForm component.
 * @property {function} onSubmit - The function to call when the form is submitted.
 * @property {boolean} isPending - Whether the form is pending.
 */
interface Props {
    onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
    isPending: boolean
}

/**
 * @function ResetPasswordForm
 * @description Component for displaying a reset password form.
 * @param {Props} props - The props for the component.
 * @returns {JSX.Element} - A React component that renders the reset password form.
 */
export function ResetPasswordForm({ onSubmit, isPending }: Props) {
    return (
        <form className="relative space-y-8" action="#" onSubmit={onSubmit}>
            <div className="rounded-md shadow-sm">
                <div className="flex flex-col">
                    <label htmlFor="login" className="text-sm font-medium pb-1">
                        Your email
                    </label>
                    <TextInput
                        id="login"
                        name="username"
                        type="email"
                        autoComplete="email"
                        required
                        className="rounded-md px-3 py-2"
                        validationError="Please, fill in your email address"
                        error={undefined}
                    />
                </div>
            </div>

            <div>
                <button
                    type="submit"
                    disabled={isPending}
                    className="group relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-base font-medium text-white disabled:opacity-75 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                    Reset Password
                </button>
            </div>
        </form>
    )
}
